export default __webpack_public_path__ + "static/media/sponsor-banner-id-m.3d6fdfa6.webp";